import React, {useEffect, useRef} from 'react';
import {Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import lottie from 'lottie-web';
import Path1 from '../Paths/path1';
import Aos from 'aos';


const useStyles=makeStyles((themes)=>({

    text:{
        textAlign:"center",
        backgroundColor:"white",
    },
    animation:{
        backgroundColor:"white",
        [themes.breakpoints.up('md')]: {
            paddingTop:"50px"
          },
    
    },
    back:{
        backgroundColor:"white",
        textAlign:"center",
        position:"relative",
        paddingTop:"220px",
        [themes.breakpoints.down('xs')]: {
            paddingTop:"10px"
          },
    },
    path1:{
        position:"absolute",
        bottom:"0px",
        margin:"auto",
        
    },
    t1:{
        margin:'auto',
        marginTop:'150px',
        [themes.breakpoints.down('xs')]: {
            marginTop:"50px"
          },
    },
    t2:{
        margin:'auto',
        color:'rgba(0,78,152)',
        fontSize:"50px",
        paddingTop:"20px",
        [themes.breakpoints.down('xs')]: {
            fontSize:"40px"
          },
    },
    t3:{
        margin:'auto',
        paddingTop:"20px"
    },
    t4:{
        margin:'auto',
        color:'rgba(58,110,165)',
        fontSize:"50px",
        paddingTop:"20px",
        [themes.breakpoints.down('xs')]: {
            fontSize:"40px"
          },
    },
}))

export default function Intro(){

    const classes =useStyles();

    const container =useRef(null);

    useEffect(()=>{

        lottie.loadAnimation({
            container:container.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: require('../Lotties/hi2.json')
        })
    },[])

    useEffect(()=>{
        Aos.init({duration:2000})
    },[])

    return(
        <div>
        
            <Grid container>
                
                <Grid item xs={1} md={2} className={classes.back}><Path1 className={classes.path1}></Path1></Grid>



                <Grid item xs={11} md={6} className={classes.text} data-aos="fade-up" data-aos-duration="3000">
                    <h2 className={classes.t1}>Hi ! I am</h2>
                    <h1 className={classes.t2}>Akash Ekanayaka</h1>
                    <h2 className={classes.t3}>I Design and Build</h2>
                    <h1 className={classes.t4}>"Websites and</h1>
                    <h1 className={classes.t4}>Mobile Apps"</h1>
                </Grid>
                <Grid item xs={12} md={4} className={classes.animation}>
                    <div ref={container}></div>
                </Grid>
            </Grid>
        </div>
    )
}

